import React from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import Sidebar from './Sidebar';
import PageContent from './PageContent';
import ActionBar from './ActionBar';
import { Contents, ContentsItems } from '../styles';
import ActionBarData from './ActionBarData';

const propTypes = {
  header: PropTypes.element,
  leftSidebar: PropTypes.element,
  rightSidebar: PropTypes.element,
  actionBar: PropTypes.node,
  content: PropTypes.element.isRequired,
  footer: PropTypes.node,
  transparent: PropTypes.bool,
  showLeftSideBar: PropTypes.bool,
  overflow: PropTypes.string
};

function WrapperData({
  header,
  leftSidebar,
  actionBar,
  content,
  footer,
  rightSidebar,
  transparent,
  showLeftSideBar,
  overflow
}) {
  return (
    <ContentsItems>
      {/* {header || ""} */}
      {showLeftSideBar && leftSidebar}
      <PageContent
        actionBar={actionBar}
        footer={footer}
        transparent={transparent || false}
        overflow={overflow}
      >
        {content}
      </PageContent>
      {rightSidebar}
    </ContentsItems>
  );
}

WrapperData.propTypes = propTypes;
WrapperData.Header = Header;
WrapperData.Sidebar = Sidebar;
WrapperData.ActionBar = ActionBarData;

export default WrapperData;



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/components/WrapperData.js